import { SCHEMEA_NS_KEY } from "../constants/Translation";
import { useSchemaContext } from "../context/SchemaContext";
import { IFormSchema } from "../models/IFormSchema";


export const useAddSchemaTranslations = (translations?: IFormSchema["translations"]) => {
    const { addTranslationResource } = useSchemaContext();

    // If there's translations, add them to the namespace
    if (translations) {
        const keys = Object.keys(translations);
        keys.forEach((key) => {
            addTranslationResource(key, SCHEMEA_NS_KEY, translations[key]);
        });
    };

    return useSchemaTranslation();
};

export const useSchemaTranslation = () => {
    const { translate: t } = useSchemaContext() || {};
    const translate = (key?: string) => key?.length ? t(SCHEMEA_NS_KEY + ":::" + key) : "";

    return { t: translate, globalT: t }
    // return useMemo(() => ({ t: translate }), [t]);
};